// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"406":"095ddd3a","444":"6662ad40","956":"112217ce"}[chunkId] + ".chunk.js";
};